module.exports = __webpack_public_path__ + "img/stock4.ba1bd445.png";